module.exports = __webpack_public_path__ + "img/wxgzh-8cm.d507420b.jpg";